export enum MapLevels {
  MAP_LEVEL_1 = 'MAP_LEVEL_1',
  MAP_LEVEL_2 = 'MAP_LEVEL_2',
  MAP_LEVEL_3 = 'MAP_LEVEL_3',
  MAP_LEVEL_4 = 'MAP_LEVEL_4',
}

export const getMapMarkerLevelPlacement = (mapLevel: MapLevels) => {
  if (mapLevel === MapLevels.MAP_LEVEL_4) return 40
  if (mapLevel === MapLevels.MAP_LEVEL_3) return 30
  if (mapLevel === MapLevels.MAP_LEVEL_2) return 20
  if (mapLevel === MapLevels.MAP_LEVEL_1) return 10
  return 1
}

export const getMapLevel = (
  isHovered?: boolean,
  isActive?: boolean,
  mostRecentTaskIsVisible?: boolean,
) => {
  if (isHovered) {
    return MapLevels.MAP_LEVEL_4
  }
  if (isActive) {
    return MapLevels.MAP_LEVEL_3
  }
  if (mostRecentTaskIsVisible) {
    return MapLevels.MAP_LEVEL_2
  }
  return MapLevels.MAP_LEVEL_1
}
